// extracted by mini-css-extract-plugin
export default {"recipes":"Recipes_recipes__XKpqC","categories":"Recipes_categories__w6-RS","meals":"Recipes_meals__t1YnD"};